// extracted by mini-css-extract-plugin
export var statItem = "_i5-1";
export var statsRow = "_i5-0";